/**
 * [ File :: G_Variable.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/text/G_ValueText.js
 * @설명 : 오브젝트의 value를 출력하는 텍스트 객체
 * @진행 : 진행중
 * @주의 :
 * @일자 : 2018.09.05
 * @작성 : Lee Mi Reu
 * @참조 :
 */
import B_Real from 'canvas/base/dev/child/base/B_Real';

const G_ValueText = (function(){

    class G_ValueText extends B_Real {
		constructor(obj) {
		    super(obj)

            this._gridDisX = obj.gridDisX
            this._gridX = obj.x
            this._gridDisY = obj.gridDisY
            this._gridY = obj.y

            this._object =
                new createjs.Text(
                    obj.text, // [#] text
                    obj.style + ' ' + obj.size + "px " + obj.font, // [#] font
                    obj.color // [#] color
                );

            this._object.textAlign = 'left'
		    this._object.textBaseline = 'alphabetic'

            this.resize()
        }

        set text(text) {
		    if (this._object.text === text) return;
		    this._object.text = text;
		    this.resize();
		}

        resize() {
            this._object.x = (this._gridX - 1) * this._gridDisX + this._gridDisX / 2
            this._object.y = (this._gridY - 1) * this._gridDisY + this._gridDisY / 2

            this._object.regX = this._gridDisX * -(this._pointX - 50) / 100 + this._object.getBounds().width / 2
            this._object.regY = this._gridDisY * -(this._pointY - 50) / 100 + this._object.getBounds().height / 2
        }

	}

	return G_ValueText

}());

export default G_ValueText;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/text/G_ValueText.js